@use "styles/abstracts/variables" as v;

.popup {
  position: absolute;
  inset: 0;
  z-index: v.$z-index-ui-popup;
  background-color: rgba(41, 41, 41, 0.2);
  backdrop-filter: blur(2px);
  pointer-events: auto;

  &Container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 0;
    text-align: center;
    vertical-align: middle;
  }

  &Children {
    width: 100%;
    display: inline-block;
    position: relative;
    z-index: v.$z-index-ui-popup;
    background-color: v.$palette-white;
    border-radius: 8px;
    line-height: normal;
  }
}
